import React, { useMemo } from "react";
import { Typography } from "@mui/material";
import ArrowBack from "../link-arrow";
import StyledSimpleHeader from "./styles";

const SimpleHeader = ({ text, icon, backArrow }) => {
  return (
    <StyledSimpleHeader>
      <div
        className={`simple-header-component ${
          backArrow ? "simple-header-component--with-arrow" : ""
        }`}
      >
        <div className={`simple-header-component-info `}>
          {icon && icon()}

          {backArrow && (
            <div className="arrow-container">
              <ArrowBack />
            </div>
          )}

          {text && (
            <div className="title-cont">
              <Typography
                variant="subtitle1"
                fontWeight={500}
              >{`${text}`}</Typography>
            </div>
          )}
        </div>
      </div>
    </StyledSimpleHeader>
  );
};

export default SimpleHeader;
